export default __webpack_public_path__ + "static/media/Rectangle 752.a93cb5f6.svg";